import { lazyLoad } from 'utils/loadable';

export const DisableTwoFactor = lazyLoad(
  () => import('./disableTwoFactor.page'),
  (module) => module.DisableTwoFactor
);
